"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersStore = exports.Permissions = void 0;
var Store_1 = require("./Store");
var Permissions;
(function (Permissions) {
    Permissions[Permissions["STAGE_1"] = 1] = "STAGE_1";
    Permissions[Permissions["STAGE_2"] = 2] = "STAGE_2";
    Permissions[Permissions["STAGE_3"] = 3] = "STAGE_3";
    Permissions[Permissions["STAGE_4"] = 4] = "STAGE_4";
    Permissions[Permissions["PRICE_QUERY_LEVEL_1"] = 5] = "PRICE_QUERY_LEVEL_1";
    Permissions[Permissions["PRICE_QUERY_LEVEL_2"] = 6] = "PRICE_QUERY_LEVEL_2";
    Permissions[Permissions["PRICE_QUERY_LEVEL_3"] = 7] = "PRICE_QUERY_LEVEL_3";
    Permissions[Permissions["PRICE_QUERY_LEVEL_4"] = 8] = "PRICE_QUERY_LEVEL_4";
    Permissions[Permissions["PRICE_QUERY_LEVEL_5"] = 9] = "PRICE_QUERY_LEVEL_5";
    Permissions[Permissions["FLEET_QUERY_LEVEL_1"] = 10] = "FLEET_QUERY_LEVEL_1";
    Permissions[Permissions["FLEET_QUERY_LEVEL_2"] = 11] = "FLEET_QUERY_LEVEL_2";
    Permissions[Permissions["FLEET_QUERY_LEVEL_3"] = 12] = "FLEET_QUERY_LEVEL_3";
    Permissions[Permissions["FLEET_QUERY_LEVEL_4"] = 13] = "FLEET_QUERY_LEVEL_4";
    Permissions[Permissions["FLEET_QUERY_LEVEL_5"] = 14] = "FLEET_QUERY_LEVEL_5";
    Permissions[Permissions["POD_QUERY_CREDIT_TEAM"] = 15] = "POD_QUERY_CREDIT_TEAM";
    Permissions[Permissions["POD_QUERY_CUSTOMER_SERVICES_TEAM"] = 16] = "POD_QUERY_CUSTOMER_SERVICES_TEAM";
    Permissions[Permissions["POD_QUERY_WAREHOUSE_TEAM"] = 17] = "POD_QUERY_WAREHOUSE_TEAM";
    Permissions[Permissions["PRICE_QUERY_LEVEL_6"] = 18] = "PRICE_QUERY_LEVEL_6";
    Permissions[Permissions["PRICE_QUERY_EDIT_LEVEL_2"] = 19] = "PRICE_QUERY_EDIT_LEVEL_2";
    Permissions[Permissions["POD_QUERY_STAGE_3_EDIT"] = 20] = "POD_QUERY_STAGE_3_EDIT";
    Permissions[Permissions["PRICE_QUERY_EDIT_LEVEL_4"] = 21] = "PRICE_QUERY_EDIT_LEVEL_4";
    Permissions[Permissions["FLEET_QUERY_LEVEL_6"] = 22] = "FLEET_QUERY_LEVEL_6";
    Permissions[Permissions["FLEET_QUERY_LEVEL_7"] = 23] = "FLEET_QUERY_LEVEL_7";
    Permissions[Permissions["REOPEN_QUERY"] = 24] = "REOPEN_QUERY";
    Permissions[Permissions["PRICE_QUERY_LEVEL_0"] = 25] = "PRICE_QUERY_LEVEL_0";
})(Permissions = exports.Permissions || (exports.Permissions = {}));
var UsersStore = /** @class */ (function (_super) {
    __extends(UsersStore, _super);
    function UsersStore(data) {
        var _this = _super.call(this, data) || this;
        _this.setData = function (data) {
            _this.data = data;
        };
        return _this;
    }
    return UsersStore;
}(Store_1.Store));
exports.UsersStore = UsersStore;
var usersStore = new UsersStore(null);
exports.default = usersStore;
